import React from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import {debounce} from 'lodash';
import PropTypes from 'prop-types';
import './index.scss';

const RESPONSIVE_THRESHOLD = 400;

export default class CardContent extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
    errorMessage: PropTypes.string,
    showError: PropTypes.bool,
    style: PropTypes.object,
  };

  static defaultProps = {
    children: [],
    errorMessage: 'Error',
    showError: false,
    style: {},
  };

  constructor(props) {
    super(props);
    this.onResize = this.onResize.bind(this);
    this.state = {};
  }

  componentDidMount() {
    this.observer = new ResizeObserver(debounce(this.onResize, 250));
    this.observer.observe(this._node);
  }

  componentWillUnmount() {
    this.observer.disconnect();
  }

  getClassName() {
    const classList = ['CardContent'];
    if (this.props.className) {
      classList.push(this.props.className);
    }
    if (this.state.isNarrow) {
      classList.push('CardContent--narrow');
    }
    return classList.join(' ');
  }

  render() {
    return (
      <div
        className={this.getClassName()}
        ref={(node) => (this._node = node)}
        style={this.props.style}>
        {this.props.showError ? (
          <span className={'CardContent-errorMessage'}>
            {this.props.errorMessage}
          </span>
        ) : (
          this.props.children
        )}
      </div>
    );
  }

  onResize() {
    if (!this._node) {
      return;
    }

    const isNarrow = this._node.offsetWidth < RESPONSIVE_THRESHOLD;
    if (this.state.isNarrow !== isNarrow) {
      this.setState({isNarrow});
    }
  }
}
